import {
    CLOSE_OUTDOOR_MAP_EDITOR,
    OPEN_OUTDOOR_MAP_EDITOR,
    OpenOutdoorMapEditorAction,
    OUTDOOR_MAP_EDITOR_CHANGE_ITEM
} from '../actions/outdoorMapEditor';
import { OutdoorMapEditorState } from '../typings/displayMap';

export const defaultOutdoorMapEditorState: OutdoorMapEditorState = {
    isVisible: false,
    groupId: '',
    checkedByRegion: undefined
};

export function outdoorMapEditor(
    state: OutdoorMapEditorState = defaultOutdoorMapEditorState,
    action: OpenOutdoorMapEditorAction
): OutdoorMapEditorState {
    switch (action.type) {
        case OPEN_OUTDOOR_MAP_EDITOR: {
            return {
                ...state,
                groupId: action.groupId,
                checkedByRegion: action.checkedByRegion,
                isVisible: true
            };
        }

        case OUTDOOR_MAP_EDITOR_CHANGE_ITEM: {
            return {
                ...state,
                checkedByRegion: action.checkedByRegion
            };
        }

        case CLOSE_OUTDOOR_MAP_EDITOR: {
            return {
                ...state,
                isVisible: false,
                checkedByRegion: undefined
            };
        }

        default:
            return state;
    }
}
